export default {
  strict: true,
  namespaced: true,
  state: {
    dispatchLogs: []
  },
  mutations: {
    resetDispatchLogs (state) {
      state.dispatchLogs = []
    },
    setDispatchLogs (state, value) {
      state.dispatchLogs = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/dispatch-logs.js